export const DOWNLOAD_VIDEO_TYPE = {
  SUBTITLE: "Subtitle",
  FONT_SIZE: "Subtitles Size",
};
